import { InputMask } from "primereact/inputmask";
import './styles.css'

function InputFormat({
  htmlFor,
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  disabled,
  mask,
  error,
  required,
  touched,
  helpText
}) {
  const hasError = touched && !!error;

  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={htmlFor}
        className={`block text-sm font-medium ${hasError ? 'text-destructive' : 'text-foreground/80'}`}>
        {label}{required && <span className="text-destructive ml-1">*</span>}
      </label>

      <InputMask
        id={id}
        name={name}
        value={value}
        onChange={(e) => onChange(e.value)}
        onBlur={onBlur}
        mask={mask}
        disabled={disabled}
        placeholder={placeholder}
        className={`
          w-full
          h-9
          px-3
          border
          text-sm
          rounded-md
          disabled:bg-muted
          outline-none
          transition-all
          duration-150
          ${hasError
            ? 'border-destructive focus:border-destructive focus:ring-2 focus:ring-destructive/20'
            : 'border-input focus:border-primary focus:ring-2 focus:ring-primary/15'
          }
        `}
      />

      {hasError ? (
        <span className="text-xs text-destructive">{error}</span>
      ) : helpText ? (
        <span className="text-xs text-muted-foreground">{helpText}</span>
      ) : null}
    </div>
  );
}

export default InputFormat;
